import uiRouter from 'angular-ui-router';
import solidarityRoutingComponent from './solidarityRouting.component';
import solidarityRoutingService from './solidarityRouting.service';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let solidarityRoutingModule = angular.module('solidarity.routing', [
  uiRouter,
])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.SOLIDARITY.ROOT, {
        abstract: true,
        parent: STATES.MAIN_ROUTING,
        url: ROUTES.SOLIDARITY.ROOT,
        component: 'solidarityRouting',
        data: {
          requiresAuth: true,
        },
        resolve: {
          /* @ngInject */
          moduleClosed: (StatusAppCheckers) => StatusAppCheckers.getClosedModules()
        }
      });
  })

  .component('solidarityRouting', solidarityRoutingComponent)

  .service('solidarityRoutingService', solidarityRoutingService)

  .name;

export default solidarityRoutingModule;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/solidarityRouting/solidarityRouting.js